import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs, companyInfo } from '../data/mock';

export const FAQ = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Encuentra respuestas a las preguntas más comunes sobre nuestros servicios
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem 
                key={faq.id} 
                value={`item-${faq.id}`}
                className="border-2 border-blue-100 rounded-lg px-6 hover:border-blue-300 transition-colors"
              >
                <AccordionTrigger className="text-left font-semibold text-blue-900 hover:text-blue-700 py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional help */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            ¿Tienes más preguntas?
          </p>
          <a 
            href={`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent('Hola, tengo una pregunta sobre sus servicios.')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 font-semibold hover:text-blue-800 underline underline-offset-4 transition-colors text-lg"
          >
            Contáctanos directamente
          </a>
        </div>
      </div>
    </section>
  );
};
